module.exports = __webpack_public_path__ + "img/SAVE_CLOSE.0cbd907d.svg";